import { createFileRoute } from '@tanstack/react-router'
import { CreateComplianceControlPage } from '../../../components/CreateComplianceControlPage'
import { PermissionDeniedState } from '../../../components/PermissionDeniedState'
import { useCan } from '../../../contexts/PermissionsContext'

export const Route = createFileRoute('/$org/compliance-controls/create')({
  component: CreateComplianceControl,
})

function CreateComplianceControl() {
  // The section's `read` guard let this caller in; creating needs `write`, so
  // a deep link to /create must not hand them a form that can only 403.
  const canWrite = useCan('compliance.write')
  if (!canWrite) return <PermissionDeniedState permission="compliance.write" />
  return <CreateComplianceControlPage />
}
